import { Col, Form, Select } from "antd";
import { useEffect, useState, useCallback } from "react";
import { getData } from "../../../apiServices/common";
import { PACKING_LINES_ENDPOINT, GET_DIGITALIZATION_APP_USERS } from "../../../apiServices/API_ENDPOINTS";

const { Option } = Select;

const PackingOperatorMappingFilterFields = ({ initialTableData }) => {
  const [packingLinesList, setPackingLinesList] = useState([]);
  const [operatorsList, setOperatorsList] = useState([]);

  // Fetch packing lines
  const getPackingLines = useCallback(async (searchValue = null) => {
    const query = `${PACKING_LINES_ENDPOINT}`;
    const bodyData = {
      ...(searchValue && { name: searchValue }),
      page: 1,
      per_page: 100,
    };

    const response = await getData(query, false, bodyData);
    if (response?.status === 200 || response?.code === 200) {
      const data = response?.data?.data?.data || response?.data?.data || [];
      setPackingLinesList(data);
    }
  }, []);

  // Fetch operators
  const getOperators = useCallback(async (searchValue = null) => {
    const query = `${GET_DIGITALIZATION_APP_USERS}`;
    const bodyData = {
      ...(searchValue && { name: searchValue }),
      page: 1,
      per_page: 100,
    };

    const response = await getData(query, false, bodyData);
    if (response?.data?.code === 200) {
      const data = response?.data?.data?.data || [];
      setOperatorsList(data);
    }
  }, []);

  useEffect(() => {
    getPackingLines();
    getOperators();
  }, [getPackingLines, getOperators]);

  return (
    <>
      <Col span={4}>
        <Form.Item label="Packing Line" name="packing_line_id">
          <Select
            showSearch
            allowClear
            placeholder="Select Packing Line"
            onSearch={(value) => getPackingLines(value)}
            onClear={() => getPackingLines()}
            optionFilterProp="children"
            filterOption={false}
            size="small"
          >
            {packingLinesList.map((line) => (
              <Option key={line.id} value={line.id}>
                {line.name}
              </Option>
            ))}
          </Select>
        </Form.Item>
      </Col>
      {/* <Col span={4}>
        <Form.Item label="Operator" name="operator_id">
          <Select
            showSearch
            allowClear
            placeholder="Select Operator"
            onSearch={(value) => getOperators(value)}
            onClear={() => getOperators()}
            optionFilterProp="children"
            filterOption={false}
            size="small"
          >
            {operatorsList.map((operator) => (
              <Option key={operator.id} value={operator.id}>
                {operator.name} ({operator.email})
              </Option>
            ))}
          </Select>
        </Form.Item>
      </Col> */}
      {/* <Col span={4}>
        <Form.Item label="Status" name="status">
          <Select
            allowClear
            placeholder="Select Status"
            size="small"
          >
            <Option value="active">Active</Option>
            <Option value="inactive">Inactive</Option>
          </Select>
        </Form.Item>
      </Col> */}
    </>
  );
};

export default PackingOperatorMappingFilterFields;

